class EntityPersistence {
    /*****************************************************/
    // START CREATION METHODS
    /*****************************************************/
    //mutates entityDataModel with what is created in the system
    async create(entityDataModel) {
        throw new Error('Subclass must implement create()!');
    }
    //mutates entityDataModel with what is cloned in the system
    async clone(entityDataModel, idOfClone) {
        throw new Error('Subclass must implement clone()!');
    }
    /*****************************************************/
    // END CREATION METHODS
    // START UPSERT METHODS
    /*****************************************************/
    //mutates entityDataModel with what is upserted in the system
    async upsert(entityDataModel) {
        throw new Error('Subclass must implement upsert()!');
    }
    /*****************************************************/
    // END UPSERT METHODS
    // START UPDATE METHODS
    /*****************************************************/
    //mutates entityDataModel with what is updated in the system
    async update(entityDataModel) {
        throw new Error('Subclass must implement update()!');
    }
    //mutates entityDataModel with what is patched in the system
    async patch(entityDataModel, patch) {
        throw new Error('Subclass must implement patch()!');
    }
    //mutates entityDataModel with what is in the system after the append
    async append(entityDataModel, pathToArray, arrayElement) {
        throw new Error('Subclass must implement append()!');
    }
    /*****************************************************/
    // END UPDATE METHODS
    // START REPLACE METHODS
    /*****************************************************/
    //mutates entityDataModel with what is replaced in the system
    async replace(entityDataModel, idToReplace = entityDataModel?.id) {
        throw new Error('Subclass must implement replace()!');
    }
    /*****************************************************/
    // END REPLACE METHODS
    // START RETRIEVAL METHODS
    /*****************************************************/
    //mutates entityDataModel with what is retrieved from the system
    async retrieve(entityDataModel, projection = undefined) {
        throw new Error('Subclass must implement retrieve()!');
    }
    async retrieveByIds(ids, projection = undefined) {
        throw new Error('Subclass must implement retrieveByIds()!');
    }
    async retrieveByProperties(propertiesFilter, projection = undefined) {
        throw new Error('Subclass must implement retrieveByProperties()!');
    }
    async retrieveAll(projection = undefined) {
        throw new Error('Subclass must implement retrieveAll()!');
    }
    //FUTURE: async retrieveByFilter(filter) { }
    /*****************************************************/
    // END RETRIEVAL METHODS
    // START DESTRUCTIVE METHODS
    /*****************************************************/
    //Removes the _lastSyncedAt & _synchronizedDataModel of entityDataModel denoting it is no longer in the system
    async delete(entityDataModel) {
        throw new Error('Subclass must implement delete()!');
    }
    /*****************************************************/
    // END DESTRUCTIVE METHODS
    /*****************************************************/
}
export { EntityPersistence };
export default EntityPersistence;